import { QUESTIONS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import questionsTypes from '../../constants/questionsTypes'
import { axios } from '../../services'

const question_image_request = () => {
  return {
    type: questionsTypes.image.request
  }
}

const question_image_success = (response) => {
  return {
    type: questionsTypes.image.success,
    payload: response.data
  }
}

const question_image_failure = (messages) => {
  return {
    type: questionsTypes.image.failure,
    payload: messages
  }
}

const question_image = (question_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(question_image_request())

    // Request
    axios({
      method: 'get',
      url: formatRoute(QUESTIONS_ROUTES.image, {id: question_id}),
      responseType: 'blob'
    }).then( response => {
      // success
      dispatch( question_image_success(response) )

    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error downloading image."]
      }
      // dispatch( try_force_logoff(error.response) )
      // window.showSnackbar('error', errors)
      dispatch( question_image_failure(errors))
    })
  }

}

export {
  question_image,
  question_image_request
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/get_image.js